import {
  LOAD_FEATURE_GEOMETRY,
  LOAD_FEATURE_GEOMETRY_FAILURE,
  LOAD_FEATURE_GEOMETRY_SUCCESS,
  LOAD_FEATURE_POPUP,
  LOAD_FEATURE_POPUP_FAILURE,
  LOAD_FEATURE_POPUP_SUCCESS, MOUSEENTER_FEATURE, MOUSELEAVE_FEATURE,
  RESET_FEATURE_SELECTION,
  SELECT_FEATURE,
} from '../actions/feature.js';

const initialState = {
  selectedData: null,
  mouseoverData: null,
  coordinates: null,
  isLoadingPopup: false,
  popupHtml: null,
  geoJson: false,
  isLoadingGeoJson: false,
};

export function featureReducer(state = initialState, action) {
  switch (action.type) {
    case SELECT_FEATURE:
      return {
        ...state,
        selectedData: action.payload.properties,
        coordinates: action.payload.coordinates,
      };
    case RESET_FEATURE_SELECTION:
      return {
        ...state,
        selectedData: null,
        coordinates: null,
        popupHtml: null,
      };
    case LOAD_FEATURE_POPUP:
      return {
        ...state,
        isLoadingPopup: true,
      };
    case LOAD_FEATURE_POPUP_SUCCESS:
      return {
        ...state,
        popupHtml: action.payload,
        isLoadingPopup: false,
      };
    case LOAD_FEATURE_POPUP_FAILURE:
      return {
        ...state,
        popupHtml: null,
        isLoadingPopup: false,
      };
    case LOAD_FEATURE_GEOMETRY:
      return {
        ...state,
        isLoadingGeoJson: true,
      };
    case LOAD_FEATURE_GEOMETRY_SUCCESS:
      return {
        ...state,
        geoJson: action.payload,
        isLoadingGeoJson: false,
      };
    case LOAD_FEATURE_GEOMETRY_FAILURE:
      return {
        ...state,
        geoJson: null,
        isLoadingGeoJson: false,
      };
    case MOUSEENTER_FEATURE:
      return {
        ...state,
        mouseoverData: action.payload,
      };
    case MOUSELEAVE_FEATURE:
      return {
        ...state,
        mouseoverData: null,
      };
    default:
      return {
        ...state,
      };
  }
}
